import { gql } from "apollo-angular";
import { environment } from "src/environments/environment";




export const SliderQuiery = (lang: string)=> gql`
{
  adsSpacesPositions(Function: "GetMainSliders")
  {
    id
    name
    AdsSpacesprice
    {
      id
      positions
      sliders
      {
        photo: photo_${lang}
        item_id
        mobile_photo:mobile_photo_${lang}
        vendor_id
        product {id name:name_${lang}}

        slider_seconds
      }
    }
  }
}
`;

export const SubCatQuiery = (lang: string)=> gql` { subCategories(home_visibleEq:1,parentIsNull:true) {
    id
    name: name_${lang}
    photo
    vendor_id
  }
}`;


export const HotDealsQuiery = gql`
 {
  offers
  {
    id
    description
    product_id
    vendor_id
    percentage
    img
    product
    {
      price
      id
      name
      photo
      description:description_ar
      rate
      rateCount
      vendor_id
    }
  }
 }`;

export const HomeCategoriesQuiery = (lang: string)=> gql`
  { categories(Function:"CategoryForHome"){
  home_photo
  id     name:name_${lang}
  vendor_id
  products(Rand:"TRUE"){ name: name_${lang}
  discount
  photo
  id
  rate
  rateCount
  price
  }

  sub_categories (limit:5) { name:name_${lang} category_id photo
  } } }


`;

export const HomeBrands = (lang: string)=> gql `
{
  brands(orderBy:sort limit: 12  home_visibleEq: 1) {
    id
    name: name_${lang}
    photo
    sub_category_id
    home_visible
  }

}`;
